import { useQuery } from '@apollo/client';
import { WatchQueryFetchPolicy } from '@apollo/client/core/watchQueryOptions';
import { IProperty } from 'interfaces/IProperty';
import { GET_PROPERTY_QUERY } from 'graphql/property';

interface PropertyQueryParams {
  id: number | undefined;
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
  onComplete?: (property: IProperty) => void;
}

interface IUsePropertyResult {
  property: IProperty | undefined;
  isLoading: boolean;
}

export const useProperty = ({
  id,
  onComplete,
  skip = false,
  fetchPolicy,
}: PropertyQueryParams): IUsePropertyResult => {
  const { data, loading } = useQuery<{ property: IProperty }>(
    GET_PROPERTY_QUERY,
    {
      variables: { id },
      skip: !id || skip,
      onCompleted: data => {
        onComplete?.(data.property);
      },
      ...(fetchPolicy ? { fetchPolicy } : {}),
    },
  );

  return { property: data?.property, isLoading: loading };
};
